import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';

const json = {
  1: { // Exercise num
    unit: 'Unit 4',
    id: 'SB4-U4-P35-E1',
    audio: 'img/FriendsPlus/Page35/Audio/audio-e1-p35.mp3',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page35/E1/Key/answerKey.png',
    textAlign: 'center',
    maxLength: 1,
    padding: 0,
    component: D1,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page35/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page35/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page35/Audio/tieude-e1-p35.mp3' },
        { url: 'img/FriendsPlus/Page35/E1/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page35/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page35/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page35/E1/6.jpg', input: true, answer: "5" },
        { url: 'img/FriendsPlus/Page35/E1/7.jpg' },
        { url: 'img/FriendsPlus/Page35/E1/8.jpg', input: true, answer: "4" },
        { url: 'img/FriendsPlus/Page35/E1/9.jpg' },
        { url: 'img/FriendsPlus/Page35/E1/10.jpg', input: true, answer: "3" },
        { url: 'img/FriendsPlus/Page35/E1/11.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page35/E1/12.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page35/E1/13.jpg' },
        { url: 'img/FriendsPlus/Page35/E1/14.jpg', input: true, answer: "2" },
        { url: 'img/FriendsPlus/Page35/E1/15.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page35/E1/16.jpg' },
      ],



    ],
  },
  2: { // Exercise num
    unit: 'Unit 4',
    id: 'SB4-U4-P35-E2',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    questionImage: [ // Row
      [
        // Column1

        { url: 'img/FriendsPlus/Page35/E2/1.jpg' },
      ],
    ],
  },
  3: { // Exercise num
    unit: 'Unit 4',
    id: 'SB1-U4-P35-E3',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page35/E3/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page35/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page35/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page35/E3/3.jpg', input: true, answer: "taking" },
        { url: 'img/FriendsPlus/Page35/E3/4.jpg' },
        { url: 'img/FriendsPlus/Page35/E3/5.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page35/E3/6.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page35/E3/7.jpg' },
        { url: 'img/FriendsPlus/Page35/E3/8.jpg', input: true, answer: "cooking" },
        { url: 'img/FriendsPlus/Page35/E3/9.jpg' },
        { url: 'img/FriendsPlus/Page35/E3/10.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page35/E3/11.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page35/E3/12.jpg' },
        { url: 'img/FriendsPlus/Page35/E3/13.jpg', input: true, answer: "writing" },
        { url: 'img/FriendsPlus/Page35/E3/14.jpg' },
        { url: 'img/FriendsPlus/Page35/E3/15.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page35/E3/16.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page35/E3/17.jpg' },
        { url: 'img/FriendsPlus/Page35/E3/18.jpg', input: true, answer: "reading" },
        { url: 'img/FriendsPlus/Page35/E3/19.jpg' },
        { url: 'img/FriendsPlus/Page35/E3/20.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page35/E3/21.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page35/E3/22.jpg' },
        { url: 'img/FriendsPlus/Page35/E3/23.jpg', input: true, answer: "listening" },
        { url: 'img/FriendsPlus/Page35/E3/24.jpg' },
        { url: 'img/FriendsPlus/Page35/E3/25.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page35/E3/26.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page35/E3/27.jpg' },
      ],

    ],
  },

}

export default json;